var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormModal',{attrs:{"title":"Wat is de gewenste breedte van de dakkapel?","show-back-btn":""},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('DormerWidthFormStep',{attrs:{"progress-value":_vm.progressValue}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }